import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { AppRootState, Status } from 'src/store/store'
import axios, { pluckData } from 'src/utilities/http-client'

export type IBSCCourseProgress = {
  id: string
  name: string
  imageName: string
  status: 'Complete' | 'Incomplete'
  hours: number
}

export type IBSCCertificate = {
  id: string
  specialCertificationID: string
  userID: string
  filePath: string
  createdTime: string
  programType: 'ibsc40' | 'ibsc100'
}

export type IBSCProgramData = {
  courses: IBSCCourseProgress[]
  totalHours: number
  requiredHours: 40 | 100
  completionPercent: number
  certificates: IBSCCertificate[]
}

export type IBSCProgressData = {
  ibsc40: IBSCProgramData
  ibsc100: IBSCProgramData
  overallCompletionPercent: number
}

type IBSCState = {
  data?: IBSCProgressData
  status: Status
}

export let initialState: IBSCState = {
  data: undefined,
  status: 'uninitialized',
}

export let fetchIBSCProgress = createAsyncThunk('ibsc/fetchIBSCProgress', () =>
  axios.get<IBSCProgressData>('/api/profile/ibsc/progress').then(pluckData),
)

export let ibscSlice = createSlice({
  name: 'ibsc',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIBSCProgress.pending, (state) => {
        state.status = 'pending'
      })
      .addCase(fetchIBSCProgress.rejected, (state) => {
        state.status = 'rejected'
      })
      .addCase(fetchIBSCProgress.fulfilled, (state, action) => {
        state.status = 'fulfilled'
        state.data = action.payload
      })
  },
})

export let selectIBSCData = (state: AppRootState) => state.ibsc.data
export let selectIBSCStatus = (state: AppRootState) => state.ibsc.status

export default ibscSlice.reducer
